export default "__VITE_ASSET__da8d8407__"